import { useTheme } from "@mui/material"
import { useContextState } from "../../../../hooks/theme"

const useStyles = () => {
  const { colors } = useContextState()
  const { breakpoints } = useTheme()
  return {
    container: {
      width: '100%',
      height: '100%',
      paddingTop: '50px',
      paddingRight: '40px',
      paddingBottom: '10px',
      paddingLeft: 1,
      overflowY: 'auto',
      overflowX: 'hidden',
      position: 'relative',
    },
    header: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: '20px',
    },
    headerLeft: {
      display: 'flex',
      width: 'fit-content',
      alignItems: 'center',
      '& .MuiIconButton-root': {
        color: colors.color4,
        fontWeight: '600',
        marginLeft: '-10px',
      },
      '& .MuiTypography-root': {
        fontSize: '17px',
        fontWeight: '400',
        color: colors.color4,
      }
    },
    title: {
      flexGrow: 1,
      fontSize: '22px',
      fontWeight: '500',
    },
    stepper: {
      width: { xl: '500px', lg: 'min-content', md: 'min-content', sm: 'min-content' },
      [breakpoints.between(1450, 1700)]: {
        width: '500px'
      }
    },
    paper: {
      padding: 4,
      minHeight: '70vh'
    },
    containerButtons: {
      display: 'flex',
      justifyContent: 'space-between',
      borderBottom: `1px solid ${colors.color39}`,
      paddingBottom: 1
    },
    currentStep: {
      marginTop: 1
    },

    areaTitle: {
      fontSize: '12px',
      color: colors.color10,
      display: 'flex',
      alignItems: 'center'
    },
    viewMore: {
      fontSize: '1rem',
      color: colors.color16,
      '& .MuiSvgIcon-root': {
        fontSize: '1em',
      },
    },
    all: {
      display: 'flex',
      alignItems: 'center',
    },
    checkLabel: {
      color: colors.color5,
      fontWeigt: '800',
      fontSize: '12px',
      maxWidth: '120px',
      wordBreak: 'break-word'
    },
    action: {
      width: '100%',
      display: 'flex',
      justifyContent: 'start',
      flexWrap: 'wrap',
      '& .MuiCheckbox-root': {
        margin: 0
      }
    },
    containerFinal: {
      minHeight: '60vh',
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      gap: 1,
      alignItems: 'center',
      justifyContent: 'center',
      '& .continue': {
        borderRadius: '4px',
        marginTop: 2
      },
    },
    icon: {
      '& .MuiSvgIcon-root': {
        width: '3em',
        height: '3em',
        color: colors.color4
      }
    },
  }
}

export { useStyles }
